import Vue from 'vue';

const state = {
    connectDialogVisible: false,
    addressDialogVisible: false,
    streets: [],
    houses: [],
    phone: '',
    tariffId: null,
    tariff: '',
    streetId: null,
    street: '',
    houseId: null,
    house: '',
    flat: '',
    type: '',
};

const mutations = {
    changeConnectParams(state, items) {
        state = Object.assign(state, items)
    },
    setConnectBlank(state) {
        state.tariffId = null;
        state.tariff = '';
        state.streetId = null;
        state.street = '';
        state.houseId = null;
        state.house = '';
        state.flat = '';
        state.type = '';
    }
};

const getters = {
    getConnect: (state) => item => {
        return item.id === state.tariffId
    },
    getConnectDialogVisible: state => state.connectDialogVisible,
    getAddressDialogVisible: state => state.addressDialogVisible,
    getConnectPhone: state => state.phone,
    getConnectStreetId: state => state.streetId,
    getConnectStreet: state => state.street,
    getConnectHouseId: state => state.houseId,
    getConnectHouse: state => state.house,
    getConnectStreets: state => {
        let streets = [];
        state.streets.forEach(street => {
            streets.push({value: street.id, text: street.city + ', ' + street.street});
        });
        return streets;
    },
    getConnectHouses: state => {
        let filterHouses = [];
        state.houses.forEach(house => {
            if (state.streetId === house.street_id)
                filterHouses.push({value: house.id, text: house.house});
        });
        return filterHouses;
    },
    getConnectType: state => state.type,
};

const actions = {
    changeConnect({commit}, items) {
        commit('changeConnectParams', items);
    },
    setConnectHouse({commit}) {
        if (state.streetId === null)
            return null;
        state.houses.forEach(house => {
            if (house.street_id === state.streetId && house.house === state.house)
                commit('changeConnectParams', {houseId: house.id});
        });
    },
    setConnectHouses({commit}) {
        commit('createProcess', 'connectHouses');
        Vue.http.get(this.getters.getApiUrl + 'v1/houses?per-page=2000sort=house').then(response => {
            commit('changeConnectParams', {houses: response.data});
            commit('setProcessSuccess', 'connectHouses');
        }, response => {
            commit('changeConnectParams', {houses: [], lastError: response.body.message});
            commit('setProcessFailed', {id: 'connectHouses', message: response.body.message});
        });
    },
    setConnectStreets({commit}) {
        commit('createProcess', 'connectStreets');
        Vue.http.get(this.getters.getApiUrl + 'v1/streets?per-page=1000&sort=street').then(response => {
            commit('changeConnectParams', {streets: response.data});
            commit('setProcessSuccess', 'connectStreets');
        }, response => {
            commit('setProcessFailed', {id: 'connectStreets', message: response.body.message});
        });
    },
    sendConnectClaim({commit}) {
        commit('createProcess', 'connect');
        let items = {phone: state.phone, type: state.type};
        if (state.tariffId !== null)
            items.tariffId = state.tariffId;
        if (state.tariff !== '')
            items.tariff = state.tariff;
        if (state.street !== '')
            items.street = state.street;
        if (state.houseId !== null)
            items.houseId = state.houseId;
        if (state.house !== '')
            items.house = state.house;
        if (state.flat !== '')
            items.flat = state.flat;
        if (this.getters.getUserContractTitle !== '')
            items.contract = this.getters.getUserContractTitle;
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/claim', items).then(response => {
            commit('setProcessSuccess', 'connect');
        }, response => {
            commit('setProcessFailed', {id: 'connect', message: response.body.message});
        });
    },
    setConnectBlank({commit}) {
        commit('setConnectBlank')
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/connect.js